import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { MaskLines, EASE } from "./Reveal";
import { WHY_ITEMS } from "../data/content";

const WhyRow = ({ item, i }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <motion.div
      ref={ref}
      data-testid={`why-item-${i + 1}`}
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: EASE }}
      className="group border-t border-charcoal/10 py-8 sm:py-10 grid sm:grid-cols-12 gap-3 sm:gap-6 items-baseline hover:bg-charcoal/[0.025] transition-colors duration-500 px-2 sm:px-4 -mx-2 sm:-mx-4 rounded-lg"
    >
      <span className="sm:col-span-2 font-mono text-xs text-ember/80">{String(i + 1).padStart(2, "0")}</span>
      <h3 className="sm:col-span-4 font-display font-bold tracking-tight text-xl sm:text-2xl text-charcoal transition-transform duration-500 group-hover:translate-x-2">
        {item.title}
      </h3>
      <p className="sm:col-span-6 text-sm sm:text-base text-charcoal/60 leading-relaxed max-w-xl">{item.copy}</p>
    </motion.div>
  );
};

export const WhyNagel = () => {
  return (
    <section data-testid="why-nagel-section" className="px-6 sm:px-10 lg:px-16 py-16 sm:py-32 max-w-[1700px] mx-auto">
      <p className="font-mono text-[10px] sm:text-xs tracking-[0.28em] text-ember mb-5">THE NAGEL STANDARD</p>
      <MaskLines
        as="h2"
        lines={[<>Experience <span className="font-serif italic font-normal">changes everything.</span></>]}
        className="font-display font-medium tracking-[-0.03em] leading-[1.05] text-3xl sm:text-5xl lg:text-[4rem] text-charcoal mb-14 lg:mb-20"
      />
      <div className="border-b border-charcoal/10">
        {WHY_ITEMS.map((item, i) => (
          <WhyRow key={item.title} item={item} i={i} />
        ))}
      </div>
    </section>
  );
};
